<script>
  export let text = '';
  export let inline = false;
  export let size = '';
  export let onClick = () => {};
  export let type = 'button';
</script>

<button
  class="bg-green-500  text-white  border-none  {size === 'lg' ? 'px-8  py-2  text-base' : 'px-4  py-1  text-sm'}  rounded  tfocus:outline-none  {inline ? 'rounded-l-none' : ''}"
  type={type}
  on:click={onClick}
>
  {text}
</button>
